import { getLocationDetails } from "@services/get_location_details";

export default function locationPredictionSelected({
  prediction,
  serviceAreaFilter,
  fns: {
    clearErrors,
    clearResults,
    keepDialogOpen,
    loadLocations,
    showNearbyLocationsPopup,
    showFixedLocationPopup,
    showLoadingAnimation,
    showResults,
    updateLocation,
    updateLocationLoadingStatus,
    updateSearchTerm,
  },
}: be.LocationPredictionSelectedFunctionArgs) {
  if (prediction.source == "fixedHudson") prediction = { ...prediction, source: "hudson" };

  if (prediction.location) {
    clearErrors();
    clearResults();

    updateLocation(prediction.location);
  } else if (prediction.source == "title" || prediction.source == "fixedHeader") {
    keepDialogOpen();
  } else if (prediction.source == "searchMeta") {
    keepDialogOpen();
    showLoadingAnimation(true);
    loadLocations(prediction.options || {}).then(function (predictions) {
      showResults(predictions);
      showLoadingAnimation(false);
    });
  } else if (prediction.source == "fixed") {
    showFixedLocationPopup(prediction.type, prediction.typestring, prediction.servicearea);
  } else if (prediction) {
    clearErrors();
    clearResults();
    updateSearchTerm(prediction.title);
    updateLocationLoadingStatus(true);

    getLocationDetails(prediction, serviceAreaFilter).then(
      ({
        enhancedPrediction,
        error,
        errorMessage,
        fklRequest,
        fklResponse,
        location,
        nearbyLocations,
      }) => {
        updateLocationLoadingStatus(false);

        if (error || (!location && !nearbyLocations?.length)) {
          updateLocation({
            ...prediction,
            displayName: prediction.title,
            displayAddress: prediction.description,
            error: errorMessage,
            fklRequest,
            fklResponse,
          });
        } else if (enhancedPrediction && nearbyLocations?.length) {
          showNearbyLocationsPopup(
            enhancedPrediction,
            nearbyLocations,
            location?.code ? location : undefined
          );
        } else {
          updateLocation(location);
        }
      }
    );
  } else {
    clearResults();
    updateLocation();
  }
}
